module.exports = __webpack_public_path__ + "img/user.9c4580fd.jpg";